export default __webpack_public_path__ + "static/FBPost-media-ac0e9bfcc20182e1bf1dfd549b25462b.png";